"use client";
import { useDialogStoreProps } from "../dialog/dialog-store.js";
import { useUpdateEffect } from "@ariakit/react-utils";
import { useStore, useStoreProps } from "@ariakit/react-store";
import * as Core from "@ariakit/components/popover/popover-store";
//#region src/popover/popover-store.ts
function usePopoverStoreProps(store, update, props) {
	useUpdateEffect(update, [props.popover]);
	useStoreProps(store, props, "placement");
	return useDialogStoreProps(store, update, props);
}
/**
* Creates a popover store to control the state of
* [Popover](https://ariakit.com/components/popover) components.
* @see https://ariakit.com/components/popover
* @example
* ```jsx
* const popover = usePopoverStore();
* <PopoverDisclosure store={popover}>Disclosure</PopoverDisclosure>
* <Popover store={popover}>Popover</Popover>
* ```
*/
function usePopoverStore(props = {}) {
	const [store, update] = useStore(Core.createPopoverStore, props);
	return usePopoverStoreProps(store, update, props);
}
//#endregion
export { usePopoverStore, usePopoverStoreProps };

//# sourceMappingURL=popover-store.js.map